import type { SERVER_TYPE } from 'js/src/typings/global';

/**
 * The per-request blob Django writes into the page (see scripts/server.js).
 *
 * Reach for this rather than `window.SERVER` directly: modules that touch the global while
 * their body runs are also imported by the server-rendering bundle, where there is no window
 * and no logged-in user. Everything is optional there, which is honest - the server renders
 * the page a signed-out visitor would get.
 */
export function getServerData(): SERVER_TYPE | undefined {
    if (typeof window === 'undefined') {
        return undefined;
    }
    return window.SERVER;
}
